// @flow
import * as React from 'react';
import Fuse from 'fuse.js';

import type { ProductSettingsList } from './utils';

type Options = {
    productSettings?: ProductSettingsList,
    searchTerm?: string
};

const useFuseSearch = ({
    productSettings,
    searchTerm
}: Options): ProductSettingsList => {
    // Construct fuse instance only when we have settings data, so that
    // Fuse.js can build the index on it.
    const fuse = React.useMemo(() => {
        return productSettings
            ? new Fuse(productSettings, {
                  useExtendedSearch: true,
                  keys: ['label', 'settingText']
              })
            : undefined;
    }, [productSettings]);

    return React.useMemo(() => {
        const result =
            fuse && searchTerm
                ? fuse.search(`'${searchTerm}`).map(({ item }) => item)
                : productSettings;
        return result ?? [];
    }, [fuse, productSettings, searchTerm]);
};

export default useFuseSearch;
